import AddIcon from '@mui/icons-material/Add';
import { CircularProgress, Fab } from '@mui/material';
import { v4 as uuid } from 'uuid';

import { useAddNewPage } from 'hooks/api/builder/useAddNewPage';
import { PageRetrieve } from 'types/api/pageRetrieve';

import { ComponentCreatorWrapper } from '../../ComponentCreator/ComponentCreator.styled';

type NewPageControlProps = {
    disabled?: boolean;
    onSuccess: (data: PageRetrieve) => void;
};

export const NewPageControl = ({
    disabled,
    onSuccess,
}: NewPageControlProps): JSX.Element => {
    const { addNewPage, loading } = useAddNewPage({
        onSuccess,
    });

    const onPageAdd = (): void => {
        addNewPage({
            uuid: uuid(),
            description: 'Описание',
            title: 'Новая страница',
        });
    };

    return (
        <ComponentCreatorWrapper>
            <Fab
                color="secondary"
                aria-label="add"
                size="medium"
                onClick={() => onPageAdd()}
                disabled={disabled || loading}
            >
                {loading ? (
                    <CircularProgress
                        variant="indeterminate"
                        color="inherit"
                        size={20}
                    />
                ) : (
                    <AddIcon />
                )}
            </Fab>
        </ComponentCreatorWrapper>
    );
};
